import { City, TConfiguration, useSearch } from '@nettbureau/featured-core';
import { TranslationProvider } from '@nettbureau/featured-translations';
import { Provider } from '@nettbureau/vibrant-ui';
import { useTranslate } from '@tolgee/react';
import { PageProps } from 'gatsby';
import { LocationCard } from '../card/LocationCard';
import { ClientSideRender } from '../ClientSideRender';
import {
  ContainerWithTheme,
  FeaturedContainer,
} from '../container/FeaturedContainer';
import { ConfigProvider } from '../provider/config-provider';
import { Header } from '../virtualized-grid/Header';
import { VirtualizedGrid } from '../virtualized-grid/VirtualizedGrid';

export default function Page(props: PageProps<object, CityListProps>) {
  return (
    <ClientSideRender>
      <Provider background={null}>
        <TranslationProvider language={props.pageContext.language}>
          <Render {...props.pageContext}></Render>
        </TranslationProvider>
      </Provider>
    </ClientSideRender>
  );
}

export interface CityListProps {
  title: string;
  hideTitle: boolean;
  language: string;
  cities: City[];
  catalogConfiguration: TConfiguration;
}

function Render(props: CityListProps) {
  const { t } = useTranslate();

  const { catalogConfiguration, title, cities, hideTitle } = props;

  const { items, numItems, query, setQuery } = useSearch({
    collection: cities,
    attributes: ['name', 'address', 'postcode', 'postarea'],
  });

  return (
    <ConfigProvider
      value={{
        globalThemeVariant: 'cityListPage',
        ...catalogConfiguration,
      }}
    >
      <ContainerWithTheme>
        <FeaturedContainer>
          <Header
            title={hideTitle ? null : title}
            resultsTitle={t('results')}
            setQuery={setQuery}
            query={query}
            numResults={numItems}
          />

          <VirtualizedGrid
            items={items}
            query={query}
            setQuery={setQuery}
            itemRenderer={(attributes, index) => {
              const { background, name, internalLink } = attributes;

              return (
                <LocationCard
                  index={index}
                  internalLink={internalLink ?? null}
                  background={background}
                  name={name}
                />
              );
            }}
          />
        </FeaturedContainer>
      </ContainerWithTheme>
    </ConfigProvider>
  );
}
